import { Tooltip, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { MRT_ColumnDef } from "material-react-table";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";



import { SysCfgRegularDto } from "@/shared/api";


export const useAiConfigTableColumns = () => {
  const { t } = useTranslation();

  return useMemo<MRT_ColumnDef<SysCfgRegularDto>[]>(
    () => [
      {
        header: t("enabled"),
        filterFn: "contains",
        accessorKey: "enabled",
        enableEditing: false,
        accessorFn: (row) => row.enabled ?? "-",
        Cell: ({ row }) => <Checkbox checked={row.original.enabled} disabled />,
        grow: true,
      },
      {
        header: t("aiConfigTable.name"),
        accessorKey: "name",
        sortingFn: "alphanumeric",
        filterFn: "contains",
      },
      {
        header: t("aiConfigTable.key"),
        accessorKey: "data.key",
        sortingFn: "alphanumeric",
        filterFn: "contains",
        Cell: ({ row }) =>
          <Tooltip
            title={<Typography
              sx={{
                maxHeight: '160px',
                overflowY: 'auto',
              }}
            >
              {(row.original.data as any)?.key}
            </Typography>}
            sx={{ fontSize: "0.8rem", padding: "4px", maxWidth: 200 , maxHeight: 100}}
          >
            <Typography
              noWrap
              sx={{ maxWidth: 250, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
            >
              {(row.original.data as any)?.key}
            </Typography>
          </Tooltip>,
      },
      {
        header: t("aiConfigTable.type"),
        accessorKey: "data.type",
        sortingFn: "alphanumeric",
        filterFn: "contains",
      }
    ],
    [t]
  );
};
